import React from "react";

const sizeClasses = {
  txtInterRegular14Bluegray40002: "font-inter font-normal",
  txtInterRegular14Bluegray500: "font-inter font-normal",
  txtInterMedium24: "font-inter font-medium",
  txtInterMedium22: "font-inter font-medium",
  txtInterSemiBold38Bluegray40001: "font-inter font-semibold",
  txtInterSemiBold24: "font-inter font-semibold",
  txtInterMedium24Black900: "font-inter font-medium",
  txtInterMedium14Gray500: "font-inter font-medium",
  txtInterBold22: "font-bold font-inter",
  txtInterBold24: "font-bold font-inter",
  txtInterMedium26: "font-inter font-medium",
  txtInterMedium26RedA700: "font-inter font-medium",
  txtInterRegular284: "font-inter font-normal",
  txtInterMedium1312: "font-inter font-medium",
  txtInterMedium24Gray40004: "font-inter font-medium",
  txtInterMedium18: "font-inter font-medium",
  txtInterMedium14Gray90001: "font-inter font-medium",
  txtInterBold14: "font-bold font-inter",
  txtInterMedium10: "font-inter font-medium",
  txtInterMedium32: "font-inter font-medium",
  txtInterMedium16: "font-inter font-medium",
  txtInterSemiBold18: "font-inter font-semibold",
  txtInterMedium26Gray40003: "font-inter font-medium",
  txtInterSemiBold38: "font-inter font-semibold",
  txtInterMedium14: "font-inter font-medium",
  txtInterMedium24BlueA700: "font-inter font-medium",
  txtInterRegular14: "font-inter font-normal",
  txtInterRegular16: "font-inter font-normal",
};

const Text = ({ children, className = "", size, as, ...restProps }) => {
  const Component = as || "p";

  return (
    <Component
      className={`text-left ${className} ${size && sizeClasses[size]}`}
      {...restProps}
    >
      {children}
    </Component>
  );
};

export { Text };
